import ReportsDetailsSettings from './ReportsDetailsSettings';

export default ReportsDetailsSettings;
